import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  template: ` <div class="text-center p-7">
    <div
      class="bg-warning text-white rounded-full inline-flex justify-center items-center w-[48px] h-[48px]"
    >
      <patternlib-icon iconName="server-error" size="24px" />
    </div>
    <h3 class="text-h3 font-head my-5">
      {{ "technical_error_title" | translate }}
    </h3>
    <p class="text-copy font-text text-gray-800">
      {{ "technical_error_text" | translate }}
    </p>
    <patternlib-button
      *ngIf="referer"
      (click)="navigateBack(referer)"
      class="mt-5"
    >
      {{ "try_again" | translate }}
    </patternlib-button>
  </div>`,
})
export class TechnicalErrorPage {
  referer: string | undefined;

  constructor(
    route: ActivatedRoute,
    private router: Router,
  ) {
    route.queryParams.subscribe((params) => {
      this.referer = params["referer"];
    });
  }

  navigateBack(referer: string) {
    this.router.navigateByUrl(referer);
  }
}
